import React from 'react';
import ArrowForwardIcon from '../../assets/icons/trvto_ArrowFarward.svg';
import ArrowBackIcon from '../../assets/icons/trvto_ArrowBack.svg';
import './pagination.css';

function Pagination(props) {
    const numberOfPages = props.numberOfRows ? Math.ceil(props.numberOfRows / props.limit) : 0;

    const getPageButtonClass = (page) => {
        const current = props.pageNumber;
        const total = numberOfPages;

        if (page === 1 || page === total) {
            return props.pageNumber === page ? 'seleNumber' : 'notSeleNumber';
        }

        const isActive = current === page;

        const isVisible =
            (current <= 3 && page <= 3) ||
            ((current === 4 || current === 5) && (page === 4 || page === 5)) ||
            (current > 5 && [current - 1, current, current + 1].includes(page));

        const baseClass = isActive ? 'seleNumber' : 'notSeleNumber';
        return `${baseClass} ${!isVisible ? 'hidePageOnSmall' : ''}`;
    };

    if (props.numberOfRows === 0) return null;

    return (
        <div className='paginationContainer'>
            <button
                onClick={() => props.paginationClick(props.pageNumber - 1, props.offSet - props.limit)}
                disabled={props.pageNumber === 1}
                className='paginationArrows'
            >
                <img src={ArrowBackIcon} alt='trvto_arrow back' />
            </button>

            <div className='numberContainer'>
                {numberOfPages < 6 ? (
                    Array.from({ length: numberOfPages }).map((_, i) => (
                        <button
                            key={i}
                            className={getPageButtonClass(i + 1)}
                            onClick={() => props.paginationClick(i + 1, i * props.limit)}
                        >
                            {i + 1}
                        </button>
                    ))
                ) : props.pageNumber < 6 ? (
                    <div className='peginationNumberDiv'>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <button
                                key={i}
                                className={getPageButtonClass(i + 1)}
                                onClick={() => props.paginationClick(i + 1, i * props.limit)}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <p className='notSeleNumberP'>...</p>
                        <button
                            className='notSeleNumber'
                            onClick={() => props.paginationClick(numberOfPages, (numberOfPages - 1) * props.limit)}
                        >
                            {numberOfPages}
                        </button>
                    </div>
                ) : props.pageNumber < numberOfPages - 2 ? (
                    <div className='peginationNumberDiv'>
                        <button className='notSeleNumber' onClick={() => props.paginationClick(1, 0)}>
                            1
                        </button>
                        <p className='notSeleNumberP'>...</p>
                        <button
                            className='notSeleNumber'
                            onClick={() =>
                                props.paginationClick(props.pageNumber - 1, (props.pageNumber - 2) * props.limit)
                            }
                        >
                            {props.pageNumber - 1}
                        </button>
                        <button
                            className='seleNumber'
                            onClick={() =>
                                props.paginationClick(props.pageNumber, (props.pageNumber - 1) * props.limit)
                            }
                        >
                            {props.pageNumber}
                        </button>
                        <button
                            className='notSeleNumber'
                            onClick={() => props.paginationClick(props.pageNumber + 1, props.pageNumber * props.limit)}
                        >
                            {props.pageNumber + 1}
                        </button>
                        <p className='notSeleNumberP'>...</p>
                        <button
                            className='notSeleNumber'
                            onClick={() => props.paginationClick(numberOfPages, (numberOfPages - 1) * props.limit)}
                        >
                            {numberOfPages}
                        </button>
                    </div>
                ) : (
                    <div className='peginationNumberDiv'>
                        {[1, 2].map((p) => (
                            <button
                                key={p}
                                className={`notSeleNumber ${p > 3 ? 'hidePageOnSmall' : ''}`}
                                onClick={() => props.paginationClick(p, (p - 1) * props.limit)}
                            >
                                {p}
                            </button>
                        ))}
                        {[numberOfPages - 3, numberOfPages - 2, numberOfPages - 1, numberOfPages].map((p) => (
                            <button
                                key={p}
                                className={getPageButtonClass(p)}
                                onClick={() => props.paginationClick(p, (p - 1) * props.limit)}
                            >
                                {p}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            <button
                onClick={() => props.paginationClick(props.pageNumber + 1, props.offSet + props.limit)}
                disabled={props.pageNumber === numberOfPages}
                className='paginationArrows'
            >
                <img src={ArrowForwardIcon} alt='trvto_arrow forward' />
            </button>
        </div>
    );
}

export default Pagination;
